<template>
    <Menubar v-if="isAdmin" class="p-1" :model="ritualMenuItems" />
</template>

<script>
import { mapGetters } from "vuex";
import roleMixins from "@/mixins/roleMixins";
import Menubar from 'primevue/menubar'
export default {
    name: "AsFicheBuMenu",
    components: {
        Menubar,
    },
    computed: {
        ...mapGetters({
            user: "getUser",
            locale: "getLocale",
            languages: "getLanguages",
        }),
    },
    watch: {
        "$i18n.locale"() {
            this.ritualMenuItems = this.getMenuItems()
        },
    },

    data() {
        return {
            ritualMenuItems: this.getMenuItems()
        };
    },
    mixins: [roleMixins],
    methods: {
        getMenuItems() {
            return [
                {
                    label: this.$t("ficheBu.title"),
                    items: [
                        {
                            label: this.$t("ficheBu.menu.priority_management"),
                            command: () => this.$router.push("/fiche-bu/priority-management"),
                        },
                        {
                            label: this.$t("ficheBu.menu.battle_management"),
                            command: () => this.$router.push("/fiche-bu/battle-management"),
                        },
                        {
                            label: this.$t("ficheBu.menu.audit_data_management"),
                            command: () => this.$router.push("/fiche-bu/audit-data-management"),
                        },
                    ],
                },
            ];
        },
    },
};
</script>

<style lang="scss"></style>
